import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {
  baseUrl: any;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseUrl;
  }

  adminSettingsCreate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-hourly-rate-markers', payload);
  }

  adminSettingsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-hourly-rate-markers', payload);
  }

  quoteSettingsCreate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quoteid-settings', payload);
  }

  quoteIdSettingsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-quoteid-settings', payload);
  }

  setTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-tls-settings', payload);
  }

  getTLSSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-tls-settings');
  }
  getClientTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/client-tls-settings', payload);
  }
  addMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/add-error', payload);
  }

  getMachineError(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/error-list', payload);
  }

  deleteMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/delete-error', payload);
  }

  blockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/block-error', payload);
  }

  unblockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/unblock-error', payload);
  }

  updateErrorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/update-error-status', payload);
  }

  addJobColour(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-color-settings', payload);
  }

  getJobColor(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-color-settings');
  }

  bulkDeleteBlockUnblock(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/bulk-update-error', payload);
  }

  testEmailSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/test101', payload);
  }

  //Proposal email
  saveProposalEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/save-proposal-settings', payload);
  }

  getProposalSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-proposal-settings');
  }

  changeJobStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-status-settings', payload);
  }

  adminRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-admin-settings', payload);
  }

  engineerRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-engineer-settings', payload);
  }

  clientRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-client-settings', payload);
  }

  getAdminSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-admin-settings');
  }

  getClientSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-client-settings');
  }

  getEngineerSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-engineer-settings');
  }

  getJobStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-status-settings');
  }

  changeQuoteStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quote-status-settings', payload);
  }

  getQuoteStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-quote-status-settings');
  }

  setQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quoteid-settings', payload);
  }

  getQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-quoteid-settings', payload);
  }

  //Industry
  industryList(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'leads/industry/industry-list', params);
  }

  createIndustry(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/industry/create', payload);
  }

  updateIndustry(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/industry/${id}/update`, payload);
  }

  deleteIndustry(id: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `leads/industry/${id}/delete`, payload);
  }

  // Manage Tag
  tagList(): Observable<any> {
    return this.http.get(this.baseUrl + 'deal/get-tag-proposal');
  }

  createTag(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-tag-proposal', payload);
  }

  updateTag(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `deal/update-tag-proposal`, payload);
  }

  deleteTag(payload: any): Observable<any> {
    return this.http.patch(this.baseUrl + `deal/soft-delete-tag-proposal`, payload);
  }

  // Manage Lead Source
  sourceList(): Observable<any> {
    return this.http.get(this.baseUrl + 'leadSource/get-all-lead-source');
  }

  createSource(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leadSource/add-lead-source', payload);
  }

  // updateSource(id: number | string, payload: any): Observable<any> {
  //   return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${id}`, payload);
  // }

  updateSource(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${payload._id}`, payload);
  }

  // deleteSource(payload: any): Observable<any> {
  //   return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${payload._id}`, payload);
  // }

  deleteSource(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${id}`);
  }

  resetApi(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `leadSource/${id}/reset-api-key`, {});
  }

  // GET lead-statuses

  // POST lead-statuses
  createOrUpdateLeadStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/lead-statuses', payload);
  }
  // DELETE lead-statuses/:id
  deleteLeadStatus(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}settings/lead-statuses/${id}`);
  }

  // Team Management APIs
  createTeam(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'team/create-team', payload);
  }

  getTeamList(page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get(`${this.baseUrl}team/list-teams?page=${page}&limit=${limit}`);
  }

  updateTeam(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}team/update-team/${id}`, payload);
  }

  deleteTeam(id: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}team/delete-team/${id}`, {});
  }

  //START HERE  FOR LMS

  getAllUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-users');
  }

  syncData(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'data-sync/sync', payload);
  }

  // Level Management APIs
  createLevel(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'level/levelcreate', payload);
  }

  getallCoursesForLevels(): Observable<any> {
    return this.http.get(this.baseUrl + 'course/getallCoursesForLevels');
  }

  getLevelList(): Observable<any> {
    return this.http.get(this.baseUrl + 'level/alllevels');
  }

  getLevelById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}level/leveldetails/${id}`);
  }

  updateLevel(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}level/updatelavel/${id}`, payload);
  }

  deleteLevel(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}level/delete/${id}`);
  }

  // Badge Management APIs
  createBadge(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'badge/badgecreate', payload);
  }

  getBadgeList(): Observable<any> {
    return this.http.get(this.baseUrl + 'badge/allbadges');
  }

  getBadgeById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}badge/badgedetails/${id}`);
  }

  updateBadge(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}badge/updatebadge/${id}`, payload);
  }

  deleteBadge(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}badge/delete/${id}`);
  }

  // Course Category Management APIs
  createCourseCategory(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course-category/categorycreate', payload);
  }

  getCourseCategoryList(): Observable<any> {
    return this.http.get(this.baseUrl + 'course-category/allcategories');
  }

  getCourseCategoryById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}course-category/categorydetails/${id}`);
  }

  updateCourseCategory(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}course-category/updatecategory/${id}`, payload);
  }

  deleteCourseCategory(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}course-category/delete/${id}`);
  }

  // Policy Management APIs (Privacy Policy, Terms & Conditions, Data Collection Policy)
  getAllPolicies(): Observable<any> {
    return this.http.get(this.baseUrl + 'policy/all');
  }

  savePolicy(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'policy/save', payload);
  }

  deletePolicy(key: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}policy/delete/${key}`);
  }

  // Product Management APIs
  createProduct(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'product/create', payload);
  }

  getProductList(): Observable<any> {
    return this.http.get(this.baseUrl + 'product/all');
  }

  updateProduct(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}product/update/${id}`, payload);
  }

  deleteProduct(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}product/delete/${id}`);
  }

  // Service Area (Pincode) APIs
  getPincodeAreas(search: string = '', isActive: string = ''): Observable<any> {
    let url = `${this.baseUrl}service-area/list?search=${search}`;
    if (isActive !== '') url += `&isActive=${isActive}`;
    return this.http.get(url);
  }

  createPincodeArea(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}service-area/create`, payload);
  }

  updatePincodeArea(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}service-area/update/${id}`, payload);
  }

  deletePincodeArea(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}service-area/delete/${id}`);
  }

  getServiceAreaAccessLogs(page: number = 1, limit: number = 20, pincode: string = '', isAvailable: string = ''): Observable<any> {
    let url = `${this.baseUrl}service-area/access-logs?page=${page}&limit=${limit}`;
    if (pincode) url += `&pincode=${pincode}`;
    if (isAvailable !== '') url += `&isAvailable=${isAvailable}`;
    return this.http.get(url);
  }

  // Business Config
  getBusinessConfigList(isActive?: boolean): Observable<any> {
    let url = `${this.baseUrl}business-config/list`;
    if (isActive !== undefined) url += `?isActive=${isActive}`;
    return this.http.get(url);
  }

  createBusinessConfig(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}business-config/create`, payload);
  }

  updateBusinessConfig(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}business-config/${id}`, payload);
  }

  deleteBusinessConfig(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}business-config/${id}`);
  }

  getDocsByBusinessCode(code: string): Observable<any> {
    return this.http.get(`${this.baseUrl}business-config/docs-by-code/${code}`);
  }
}
